import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {

  @ViewChild('dropdown', { static: false }) dropdown!: ElementRef;
  user: any;
  profile: any;
  dropdownOpen: boolean = false;

  constructor(
    private sessionService: SessionService
  ) {
    this.user = this.sessionService.getUser();
    this.profile = this.sessionService.getUserProfile();
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  } 

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.dropdownOpen && this.dropdown && !this.dropdown.nativeElement.contains(event.target)) {
      this.dropdownOpen = false;
    }
  }

  logout() {
    this.sessionService.logOut();
  }
}
